import { createFileRoute } from "@tanstack/react-router";
import { DatePage } from "@/components/pages/DatePage";
import { todayISO, parseISO, formatLong, calendarDatePath } from "@/lib/calendar/dates";
import { withSlash } from "@/lib/url";

/**
 * /hari-ini renders today's date directly (200 OK, not a redirect).
 * Sitemap and internal nav reference this stable URL; canonical points
 * to today's dated page so Google consolidates ranking signals.
 */
export const Route = createFileRoute("/hari-ini")({
  loader: () => parseISO(todayISO())!,
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { y, m, d } = loaderData;
    const longDate = formatLong(y, m, d);
    const title = `Hari Ini ${longDate} - Hari Apa, Weton & Hijriah`;
    const desc = `Hari ini ${longDate}: hari, weton Jawa, kalender Hijriah, Bali, status libur nasional, dan hari penting.`;
    const canonical = `https://hari.co.id${withSlash(calendarDatePath(y, m, d))}`;
    const here = `https://hari.co.id/hari-ini/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: here },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: HariIniPage,
});

function HariIniPage() {
  const { y, m, d } = Route.useLoaderData();
  return <DatePage y={y} m={m} d={d} locale="id" />;
}